import { useContext } from 'react';
import { store } from '../store';

const useConfig = () => {
    const { state: { config } } = useContext(store);
    return config;
};

export default useConfig;
